const brands = {
    'A': [
        { name: 'Argos', url: '/collections/argos' },
        { name: 'Acqua Di Parma', url: '/collections/acqua-di-parma' }
    ],
    'B': [
        { name: 'BDK Parfums', url: '/collections/bdk' },
        { name: 'Boadicea', url: '/collections/boadicea' },
        { name: 'Bond No 9 ', url: '/collections/bond-no-9' }
    ],
    'C': [
        { name: 'Carolina Herrera', url: '/collections/carolina-herrera' },
        { name: 'Chanel', url: 'collections/chanel ' },
        { name: 'Clive Christian', url: '/collections/clive-christian' },
        { name: 'Creed', url: '/collections/creed  ' }
    ],
    'D': [
        { name: 'Dior', url: '/collections/dior ' }
    ],
    'E': [
        { name: 'Escentric Molecules', url: '/collections/escentric-molecules ' }
    ],
    'F': [
        
    ],
    'G': [
        { name: 'Giardini Di Toscana', url: '/collections/giardini-di-toscana' },
    ],
    'H': [
        { name: 'Harmonist', url: '/collections/the-harmonist' }
    ],
    'I': [
        { name: 'Initio', url: '/collections/initio' }
    ],
    'J': [
        { name: 'Jimmy Choo', url: '/collections/jimmy-choo ' },
        { name: 'Jo Malone London', url: '/collections/jo-malone' }
    ],
    'K': [
        { name: 'Kilian', url: '/colltions/kilian' }
    ],
    'L': [
        { name: 'Lancome', url: '/collections/lancome ' },
        { name: 'Loumari', url: '/collections/loumari' },
        { name: 'Louis Vuitton', url: '/collections/louis-vuitton' }
    ],
    'M': [
        { name: 'Maison Francis Kurkdjian', url: '/collections/maison-francis-kurkdjian ' },
        { name: 'Maison Crivelli', url: '/collections/maison-crivelli ' },
        { name: 'Marc Jacobs', url: '/collections/marc-jacobs ' },
        { name: 'Mind Games', url: '/collections/mind-games' },
        {name: 'Micallef', url: '/collections/micallef'},
        {name: 'Montale', url: '/collections/montale '}
    ],
    'N': [

    ],
    'O': [
       
    ],
    'P': [
        { name: 'Paco Rabanne', url: '/collections/paco-rabanne' },
        { name: 'Parfums de Marly', url: '/collections/parfums-de-marly' },
        { name: 'Pana Dora', url: '/collections/pana-dora' },
        { name: 'Prada', url: '/collections/prada' }
    ],
    'Q': [
        
    ],
    'R': [
        { name: 'Ralph Lauren', url: '/collections/ralph-lauren' }
       
    ],
    'S': [
        
    ],
    'T': [
        { name: 'Tom Ford', url: '/collections/tom-ford' },
        { name: 'Tommy Hilfiger', url: '/collections/tiziana-terenzi ' }
    ],
    'U': [
        
    ],
    'V': [
        { name: 'Valentino', url: '/collections/valentino ' },
        { name: 'Versace', url: '/collections/versace' },
        { name: 'Viktor & Rolf', url: '/collections/viktor-rolf ' }
    ],
    'W': [
       
    ],
    'X': [
        { name: 'Xerjoff', url: '/collections/xerjoff ' }
    ],
    'Y': [
        { name: 'Yves Saint Laurent', url: '/collections/yves-saint-laurent ' }
    ],
    'Z': [
       
    ]
};

// Function to create brand sections
function createBrandSections() {
    const brandList = document.getElementById('brandList');
    console.log('Brand List Element:', brandList); // Debug line

    for (let letter in brands) {
        if (brands[letter].length > 0) {
            const section = document.createElement('div');
            section.className = 'brand-section';
            section.id = letter;

            // Debug the HTML being created
            const html = `
                <h2>${letter}</h2>
                <ul>
                    ${brands[letter].map(brand => `
                        <li><a href="${brand.url}">${brand.name}</a></li>
                    `).join('')}
                </ul>
            `;
            console.log('Section HTML:', html); // Debug line
            
            section.innerHTML = html;
            brandList.appendChild(section);
        }
    }
}


// Search functionality
function setupSearch() {
    const searchInput = document.getElementById('brandSearch');
    
    searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        const sections = document.querySelectorAll('.brand-section');
        
        sections.forEach(section => {
            const items = section.querySelectorAll('li');
            let hasVisibleItems = false;
            
            items.forEach(item => {
                const brandName = item.textContent.toLowerCase();
                if (brandName.includes(searchTerm)) {
                    item.style.display = '';
                    hasVisibleItems = true;
                } else {
                    item.style.display = 'none';
                }
            });
            
            // Show/hide the entire section based on whether it has visible items
            section.style.display = hasVisibleItems ? '' : 'none';
        });
    });
}

// Smooth scrolling for alphabet navigation
function setupSmoothScroll() {
    document.querySelectorAll('.alphabet-nav a').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Initialize everything when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    createBrandSections();
    setupSearch();
    setupSmoothScroll();
});